import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsInlineSkateNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 0v.146a2 2 0 00.936 1.694L6.631.71A3 3 0 019.244.36l3.705 1.235A3 3 0 0114.967 4H16v2h-.969a4 4 0 001.184 2.37l.578-.577 1.414 1.414-.399.399.114.085c.34.256.73.44 1.143.544l.612.153A4.388 4.388 0 0123 14.644c0 .62-.24 1.185-.632 1.606l.169.252c.398.598.466 1.278.289 1.878A2.5 2.5 0 1119.05 20h-1.1a2.5 2.5 0 11-4.9 0h-1.1a2.5 2.5 0 11-4.9 0h-1.1a2.5 2.5 0 11-4.233-1.253A2.23 2.23 0 011.6 17.04l.92-2.76a6.623 6.623 0 01-.26-3.828l1.594-6.93A4 4 0 012 .147V0zm4.612 2.257a1 1 0 00-.871.117L5.885 3.611l-.908 3.951 2.1 2.1a1 1 0 001.507-.107L10.5 7h2.69a5.985 5.985 0 01-.17-1H8V4h4.897a1 1 0 00-.58-.508zM14.127 9H11.5l-1.316 1.755a3 3 0 01-4.522.321L4.448 9.863l-.239 1.037a4.623 4.623 0 00.37 3.1H8c1.651 0 2.516.285 3.316.552l.017.005c.694.232 1.33.443 2.667.443h6.645a.355.355 0 00.355-.355c0-1.095-.746-2.05-1.808-2.316l-.613-.153a5.194 5.194 0 01-1.857-.884l-.342-.257-2.673 2.673-1.414-1.414L14.8 9.785A5.998 5.998 0 0114.127 9zm-10.63 8.67a.25.25 0 00.237.33h16.93a.25.25 0 00.208-.389L20.464 17H14c-1.651 0-2.516-.284-3.316-.55l-.017-.007C9.973 16.212 9.337 16 8 16H4.054z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsInlineSkateNormalSmall;
